import axiosClient from 'util/axiosClient';

/**
 * Anything related to Authentication in the system.
 */
export default class PropertyService {
    static addAdmin(property) {
        return axiosClient
            .post(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property`, property)
            .then((response) => response.data);
    }

    static get(id) {
        return axiosClient
            .get(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/property/${id}`)
            .then((response) => response.data);
    }

    static getAll() {
        return axiosClient
            .get(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/property`)
            .then((response) => response.data);
    }

    static getAllAdmin() {
        return axiosClient
            .get(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property`)
            .then((response) => response.data);
    }

    static archiveAdmin(id) {
        return axiosClient
            .post(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property/${id}/archive`)
            .then((response) => response.data);
    }

    static undoArchiveAdmin(id) {
        return axiosClient
            .post(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property/${id}/archive/undo`)
            .then((response) => response.data);
    }

    static closeBidding(id) {
        return axiosClient
            .post(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property/${id}/bidding-status/close`)
            .then((response) => response.data);
    }

    static openBidding(id) {
        return axiosClient
            .post(`${process.env.REACT_APP_PROPERTY_SERVICES_URL}/admin/property/${id}/bidding-status/open`)
            .then((response) => response.data);
    }
}
